"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var AttachmentAudioIcon = function AttachmentAudioIcon(props) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.34,12.18V4.68a1.08,1.08,0,1,1,2.16,0c0,1,0,2.1,0,3.16V19.67a1.08,1.08,0,1,1-2.16,0V12.18Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.75,12.18V17a1.08,1.08,0,1,1-2.16,0c0-1.37,0-2.74,0-4.12,0-1.85,0-3.69,0-5.54a1.08,1.08,0,1,1,2.16,0Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.85,12.17c0-1.43,0-2.85,0-4.28A1.08,1.08,0,1,1,6,7.91v8.55a1.08,1.08,0,1,1-2.16,0C3.85,15,3.85,13.6,3.85,12.17Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.26,12.19c0,.72,0,1.43,0,2.15a1.07,1.07,0,0,1-1.64.92,1,1,0,0,1-.52-.91c0-1.44,0-2.89,0-4.34a1.08,1.08,0,0,1,2.16,0C9.27,10.75,9.26,11.47,9.26,12.19Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19,12.19c0,.72,0,1.43,0,2.15a1.07,1.07,0,0,1-1.64.92,1,1,0,0,1-.52-.91V10A1.08,1.08,0,0,1,19,10C19,10.75,19,11.47,19,12.19Z"
  })), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "-0.02",
    width: "23.99",
    height: "23.99",
    fill: "none"
  }));
};

var _default = AttachmentAudioIcon;
exports["default"] = _default;
//# sourceMappingURL=AttachmentAudio.js.map